import { buffers, type EventChannel, eventChannel } from 'redux-saga'

import { streamChat } from '../../v2/chatAgentClient'
import type { ChatAgentStreamItem } from '../../v2/types'

export interface ChatAgentChannelParams {
  projectId: string
  content: string
  signal: AbortSignal
}

/**
 * Wraps the chat-agent SSE stream into a saga event channel. The channel
 * never emits END on its own — terminal items (`done` / `stream_end` /
 * `stream_failure`) let the consumer decide how to finish; the consumer
 * closes the channel and aborts the fetch via its AbortController.
 */
export const createChatAgentChannel = ({
  projectId,
  content,
  signal,
}: ChatAgentChannelParams): EventChannel<ChatAgentStreamItem> =>
  eventChannel<ChatAgentStreamItem>((emit) => {
    streamChat({ projectId, content, signal, onEvent: emit })
      .then(() => emit({ type: 'stream_end' }))
      .catch((error) => emit({ type: 'stream_failure', error }))

    // Cancellation happens through the AbortController owned by the saga.
    return () => {}
  }, buffers.expanding<ChatAgentStreamItem>())
